import React from 'react';
import './skeleton.css';

/**
 * 사이드바 스켈레톤 UI 컴포넌트
 * 사이드바 메뉴가 로딩 중일 때 표시
 */
const SidebarSkeleton = ({ position = 'left' }) => {
  return (
    <div className={`sidebar-skeleton sidebar-${position}`}>
      <div className="card">
        <div className="card-body">
          {/* 제목 스켈레톤 */}
          <div className="skeleton-title mb-4">
            <div className="skeleton-line" style={{ width: '60%', height: '24px', marginBottom: '8px' }}></div>
          </div>

          {/* 메뉴 항목 스켈레톤 */}
          <div className="skeleton-menu-items">
            {[1, 2, 3, 4, 5].map((item) => (
              <div key={item} className="skeleton-menu-item mb-3">
                <div className="d-flex align-items-center">
                  <div className="skeleton-line" style={{ width: '70%', height: '20px' }}></div>
                  <div className="skeleton-line ms-auto" style={{ width: '16px', height: '16px', borderRadius: '4px' }}></div>
                </div>
                {/* 서브메뉴 스켈레톤 (일부 항목에만) */}
                {item <= 2 && (
                  <div className="skeleton-submenu mt-2 ms-3">
                    {[1, 2].map((subItem) => (
                      <div key={subItem} className="skeleton-line mb-2" style={{ width: '60%', height: '18px' }}></div>
                    ))}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SidebarSkeleton;

